<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
      <notifications group="foo" position="bottom left"/>
    </div>
    <router-view name="footer" />
  </div>
</template>
<script>
export default {};
</script>
<style>
#id{
  min-width: 900px;
}
</style>
